import { defineMessages } from 'react-intl-next';

import AiGenerativeAudioBriefingIcon from '@atlaskit/icon-lab/core/ai-generative-audio-briefing';
import TextAudioTranscriptIcon from '@atlaskit/icon-lab/core/text-audio-transcript';
import CustomizeIcon from '@atlaskit/icon/core/customize';
import LinkIcon from '@atlaskit/icon/core/link';

import { type AudioFeature, AudioFeatureType } from '@atlassian/ai-audio';

const i18n = defineMessages({
	narrationLabel: {
		id: 'audio.audio-features.narration-label',
		defaultMessage: 'Narration',
		description: 'Label for the narration feature',
	},
	briefingLabel: {
		id: 'audio.audio-features.briefing-label',
		defaultMessage: 'Briefing',
		description: 'Label for the briefing feature',
	},
	personalizeLabel: {
		id: 'audio.audio-features.personalize-menu-item-label',
		defaultMessage: 'Personalize',
		description: 'Label for the personalize menu item',
	},
	manageSourcesLabel: {
		id: 'audio.audio-features.manage-sources-menu-item-label',
		defaultMessage: 'Manage sources',
		description: 'Label for the manage sources menu item',
	},
});

export const audioFeatures: AudioFeature[] = [
	{
		name: AudioFeatureType.BRIEFING,
		translationString: i18n.briefingLabel,
		icon: AiGenerativeAudioBriefingIcon,
		menuConfig: {
			items: [
				{
					label: i18n.personalizeLabel,
					onClick: () => {},
					title: i18n.personalizeLabel,
					icon: CustomizeIcon({ label: '' }),
				},
				{
					label: i18n.manageSourcesLabel,
					onClick: () => {},
					title: i18n.manageSourcesLabel,
					icon: LinkIcon({ label: '' }),
				},
			],
		},
	},
	{
		name: AudioFeatureType.NARRATION,
		translationString: i18n.narrationLabel,
		icon: TextAudioTranscriptIcon,
	},
];
